import React from 'react'
import IconProvider from './IconProvider'

const wrapApp = context => {
	context.app = <IconProvider>{context.app}</IconProvider>
}

export default wrapApp
